import { IRole } from 'graphql/types';
import { translate } from 'utils/i18n';

export const getRoleTranslation = (role: IRole) => {
    switch (role) {
        case IRole.Owner:
            return translate('roles.owner');
        case IRole.Manager:
            return translate('roles.manager');
        case IRole.Planner:
            return translate('roles.planner');
        case IRole.Author:
            return translate('roles.author');
        case IRole.Trainer:
            return translate('roles.trainer');
    }
};
